/* ICHIGON 商品ページ挙動 v3:
   - ロゴ選択→定番生地へ自動切替
   - 無効な組み合わせのBodyは常時無効化（テーマのDOM再描画にMutationObserverで追従）
   - 無効な選択状態に陥ったら定番生地へ矯正 */
(function () {
  var DEFAULTS = { "Black logo": "White", "White logo": "Black" };
  var variants = null;
  var applying = false;

  var css = document.createElement("style");
  css.textContent =
    "fieldset input[type=radio][data-ig-off]{pointer-events:none;}" +
    "fieldset input[type=radio][data-ig-off]+label{opacity:.28;pointer-events:none;" +
    "text-decoration:none !important;}" +
    "fieldset input[type=radio]+label,fieldset input[type=radio]+label span" +
    "{text-decoration:none !important;}";
  document.head.appendChild(css);

  function loadVariants() {
    var m = location.pathname.match(/\/products\/([^\/\?]+)/);
    if (!m) return;
    fetch("/products/" + m[1] + ".js").then(function (r) { return r.json(); })
      .then(function (p) { variants = p.variants || []; apply(); observe(); })
      .catch(function () {});
  }

  function fieldsetOf(name) {
    var fss = document.querySelectorAll("fieldset");
    for (var i = 0; i < fss.length; i++) {
      var lg = fss[i].querySelector("legend");
      if (lg && lg.textContent.trim().indexOf(name) === 0) return fss[i];
    }
    return null;
  }
  function checkedVal(name) {
    var fs = fieldsetOf(name);
    var r = fs && fs.querySelector("input[type=radio]:checked");
    return r ? r.value : null;
  }
  function setBody(value) {
    var fs = fieldsetOf("Body");
    if (!fs) return;
    var radios = fs.querySelectorAll("input[type=radio]");
    for (var j = 0; j < radios.length; j++) {
      if (radios[j].value === value && !radios[j].checked) {
        radios[j].checked = true;
        radios[j].dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  function apply() {
    if (!variants || applying) return;
    applying = true;
    try {
      var logo = checkedVal("Logo");
      if (!logo) return;
      var valid = {};
      variants.forEach(function (v) {
        var opts = [v.option1, v.option2, v.option3];
        if (opts.indexOf(logo) !== -1) opts.forEach(function (o) { valid[o] = true; });
      });
      var fs = fieldsetOf("Body");
      if (!fs) return;
      fs.querySelectorAll("input[type=radio]").forEach(function (r) {
        if (valid[r.value]) r.removeAttribute("data-ig-off");
        else r.setAttribute("data-ig-off", "1");
      });
      var body = checkedVal("Body");
      if (body && !valid[body]) {
        applying = false;
        setBody(DEFAULTS[logo] || "White");
        return;
      }
    } finally { applying = false; }
  }

  var t = null;
  function observe() {
    new MutationObserver(function () {
      clearTimeout(t); t = setTimeout(apply, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("change", function (e) {
    var input = e.target;
    if (!input || input.type !== "radio" || applying) return;
    var fs = input.closest("fieldset");
    var lg = fs && fs.querySelector("legend");
    if (lg && /^\s*Logo/i.test(lg.textContent)) {
      setBody(DEFAULTS[input.value] || "White");
    }
    clearTimeout(t); t = setTimeout(apply, 80);
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", loadVariants);
  else loadVariants();
})();
